<ng-container *ngIf="!mostrandoFormulario; else formularioTpl">
  <div class="header">
    <p class="section-title">TODOS OS REGISTROS</p>
    <button matButton="filled" class="add-btn" (click)="abrirNovoRegistro()">
      <mat-icon>add</mat-icon>
      Adicionar registro
    </button>
  </div>
<!-- Os dados acima correspondem para adicionar  -->


  <div class="container-registro" *ngIf="registros && registros.length > 0">
    <div class="consulta-exames" *ngFor="let registro of registros">
      <div class="dados-registro">
        <p class="profissional">
          Profissional responsável: {{ registro.nomeProfissional }}
        </p>

        <div class="wrap-datas">
          <img alt="calendário" src="../../../../assets/svg/icons/calendario.svg" />
          <p>{{ formatarData(registro.dataConsulta) }}</p>
          <img alt="horário" src="../../../../assets/svg/icons/clock.svg" />
          <p>{{ registro.horarioConsulta }}</p>
        </div>

        <p class="apontamentos" *ngIf="registro.apontamentos">
          {{ registro.apontamentos }}
        </p>
      </div>

      <button class="acessar-plano-btn" (click)="editarRegistro(registro)">
        Editar
      </button>
    </div>
  </div>

  <p class="sem-registro" *ngIf="!registros || registros.length === 0">
    Nenhum registro de consulta ou exame adicionado.
  </p>
</ng-container>
<!-- Os dados acima correspondem para Listagem caso tenha algum Registro -->


<!-- Os abaixo são realmente a Tela Geral com os dados -->
<ng-template #formularioTpl>
  <section>
    <p class="section-title">INFORMAÇÕES DA CONSULTA</p>

    <div class="grid grid-6">
      <mat-form-field
        appearance="outline"
        class="span-3 full-width has-prefix-icon hide-native-placeholder"
        [class.has-value]="!!dataConsulta"
      >
        <mat-label>Data da consulta</mat-label>
        <img matPrefix class="prefix-svg" alt="calendário" src="../../../../assets/svg/icons/calendario.svg" />
        <input
          matInput
          type="text"
          name="dataConsulta"
          mask="00/00/0000"
          [dropSpecialCharacters]="false"
          placeholder="dd/mm/aaaa"
          [(ngModel)]="dataConsulta"
          #dataCtrl="ngModel"
          required
          [disabled]="formBloqueado()"
        />
        <mat-error *ngIf="dataCtrl.invalid && (dataCtrl.touched || submitted)">
          Data da consulta é obrigatória
        </mat-error>
      </mat-form-field>

      <mat-form-field
        appearance="outline"
        class="span-3 full-width has-prefix-icon hide-native-placeholder"
        [class.has-value]="!!horarioConsulta"
      >
        <mat-label>Horário da consulta</mat-label>
        <img matPrefix class="prefix-svg" alt="horário" src="../../../../assets/svg/icons/clock.svg" />
        <input
          matInput
          type="text"
          name="horarioConsulta"
          mask="00:00"
          [dropSpecialCharacters]="false"
          placeholder="00:00"
          [(ngModel)]="horarioConsulta"
          #horarioCtrl="ngModel"
          required
          [disabled]="formBloqueado()"
        />
        <mat-error *ngIf="horarioCtrl.invalid && (horarioCtrl.touched || submitted)">
          Horário da consulta é obrigatório
        </mat-error>
      </mat-form-field>


      <mat-form-field appearance="outline" class="span-6 full-width">
        <mat-label>Profissional responsável</mat-label>
        <input
          matInput
          type="text"
          name="nomeProfissional"
          [(ngModel)]="nomeProfissional"
          #profCtrl="ngModel"
          required
          minlength="3"
          maxlength="150"
          [disabled]="formBloqueado()"
        />
        <mat-error *ngIf="profCtrl.invalid && (profCtrl.touched || submitted)">
          <span *ngIf="profCtrl.errors?.['required']">Nome do profissional é obrigatório</span>
          <span *ngIf="profCtrl.errors?.['minlength']">Mínimo de 3 caracteres</span>
          <span *ngIf="profCtrl.errors?.['maxlength']">Máximo de 150 caracteres</span>
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="span-6 full-width">
        <mat-label>Apontamentos</mat-label>
        <textarea
          matInput
          rows="5"
          name="apontamentos"
          [(ngModel)]="apontamentos"
          #apoCtrl="ngModel"
          required
          minlength="15"
          maxlength="1000"
          [disabled]="formBloqueado()"
        ></textarea>
        <mat-hint align="end">{{ (apontamentos?.length || 0) }}/1000</mat-hint>
        <mat-error *ngIf="apoCtrl.invalid && (apoCtrl.touched || submitted)">
          <span *ngIf="apoCtrl.errors?.['required']">Apontamentos são obrigatórios</span>
          <span *ngIf="apoCtrl.errors?.['minlength']">Mínimo de 15 caracteres</span>
        </mat-error>
      </mat-form-field>
    </div>
  </section>
  <ng-container [ngSwitch]="modoLinhaCuidado">

    <!-- DOR LOMBAR (id=1) -->
    <ng-container *ngSwitchCase="'LOMBAR'">
      <section>
        <p class="section-title">CLASSIFICAÇÃO EVA</p>

        <section class="eva-section">
        <div class="eva-container">
            <span class="eva-main-label">Classificação EVA:</span>

            <mat-radio-group [(ngModel)]="moviaClassificacaoEva" [disabled]="formBloqueado()" class="eva-radio-group">
                <mat-radio-button 
                    *ngFor="let n of [0,1,2,3,4,5,6,7,8,9,10]" 
                    [value]="n" 
                    class="custom-radio">
                    {{ n }}
                </mat-radio-button>
            </mat-radio-group>
        </div>
        </section>

        <div class="grid grid-6" style="margin-top: 12px;">
          <mat-form-field appearance="outline" class="span-3 full-width">
            <mat-label>Frequência da dor</mat-label>
            <mat-select [(ngModel)]="moviaFrequenciaDor" [disabled]="formBloqueado()">
              <mat-option *ngFor="let opt of moviaFrequenciaDorOptions" [value]="opt.value">
                {{ opt.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="span-3 full-width">
            <mat-label>Melhora na postura</mat-label>
            <mat-select [(ngModel)]="moviaMelhoraPostura" [disabled]="formBloqueado()">
              <mat-option *ngFor="let opt of moviaMelhoraPosturaOptions" [value]="opt.value">
                {{ opt.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </section>
    </ng-container>

    <!-- SOBREPESO E OBESIDADE (id=2) -->
    <ng-container *ngSwitchCase="'SOBREPESO'">
  <section>
    <p class="section-title">INFORMAÇÕES DA LINHA DE CUIDADO</p>
    <p *ngIf="linhaDeCuidadoLabel">{{ linhaDeCuidadoLabel }}</p>

    <mat-grid-list cols="6" rowHeight="90px" gutterSize="1em">
          <mat-grid-tile [colspan]="2">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Peso</mat-label>
              <input
                matInput
                type="text"
                mask="separator.2"
                decimalMarker=","
                thousandSeparator="."
                placeholder="000,00"
                [(ngModel)]="equilibriaPeso"
                (blur)="formatDecimal2('equilibriaPeso')"
                [disabled]="formBloqueado()"
              />
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="2">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Circunferência abdominal</mat-label>
              <input
                matInput
                type="text"
                mask="separator.2"
                decimalMarker=","
                thousandSeparator="."
                placeholder="000,00"
                [(ngModel)]="equilibriaCircunferenciaAbdominal"
                (blur)="formatDecimal2('equilibriaCircunferenciaAbdominal')"
                [disabled]="formBloqueado()"
              />
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="2">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Frequência de atividade física</mat-label>
              <mat-select [(ngModel)]="frequenciaAtividadeFisica" [disabled]="formBloqueado()">
                <mat-option *ngFor="let opt of frequenciaAtividadeFisicaOptions" [value]="opt.value">
                  {{ opt.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </mat-grid-tile>
        </mat-grid-list>
      </section>
    </ng-container>

    <!-- DEFAULT (se não tiver linha) -->
    <ng-container *ngSwitchDefault>
    </ng-container>

  </ng-container>
  <section>
    <p class="section-title">SF36</p>

    <mat-grid-list cols="6" rowHeight="90px" gutterSize="1em">
      <mat-grid-tile [colspan]="3">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Capacidade funcional</mat-label>
          <input matInput type="number" [(ngModel)]="sf36CapacidadeFuncional" [disabled]="formBloqueado()" />
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="3">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Limitação por aspectos físicos</mat-label>
          <input matInput type="number" [(ngModel)]="sf36LimitacaoAspectosFisico" [disabled]="formBloqueado()" />
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="3">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Dor</mat-label>
          <input matInput type="number" [(ngModel)]="sf36Dor" [disabled]="formBloqueado()" />
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="3">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Estado geral de saúde</mat-label>
          <input matInput type="number" [(ngModel)]="sf36EstadoGeralSaude" [disabled]="formBloqueado()" />
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="3">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Vitalidade</mat-label>
          <input matInput type="number" [(ngModel)]="sf36Vitalidade" [disabled]="formBloqueado()" />
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="3">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Aspectos sociais</mat-label>
          <input matInput type="number" [(ngModel)]="sf36AspectosSociais" [disabled]="formBloqueado()" />
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="3">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Limitação por aspectos emocionais</mat-label>
          <input matInput type="number" [(ngModel)]="sf36LimitacaoAspectosEmocionais" [disabled]="formBloqueado()" />
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="3">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Saúde mental</mat-label>
          <input matInput type="number" [(ngModel)]="sf36SaudeMental" [disabled]="formBloqueado()" />
        </mat-form-field>
      </mat-grid-tile>
    </mat-grid-list>
  </section>

  <div class="form-actions">
    <button matButton="outlined" type="button" (click)="cancelar()">
      Cancelar
    </button>

    <button
      matButton="filled"
      type="button"
      [disabled]="formBloqueado() || salvando"
      (click)="salvar()"
    >
      Salvar
    </button>
  </div>
</ng-template>
